"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IteratorObservable = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _root = require("../util/root");

var _Observable2 = require("../Observable");

var _iterator = require("../symbol/iterator");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(IteratorObservable, _Observable);

  function IteratorObservable(iterator, scheduler) {
    var _this;

    (0, _classCallCheck2.default)(this, IteratorObservable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IteratorObservable).call(this));
    _this.scheduler = scheduler;

    if (iterator == null) {
      throw new Error('iterator cannot be null.');
    }

    _this.iterator = getIterator(iterator);
    return _this;
  }

  (0, _createClass2.default)(IteratorObservable, [{
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var index = 0;
      var iterator = this.iterator,
          scheduler = this.scheduler;

      if (scheduler) {
        return scheduler.schedule(IteratorObservable.dispatch, 0, {
          index: index,
          iterator: iterator,
          subscriber: subscriber
        });
      } else {
        do {
          var result = iterator.next();

          if (result.done) {
            subscriber.complete();
            break;
          } else {
            subscriber.next(result.value);
          }

          if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
              iterator.return();
            }

            break;
          }
        } while (true);
      }
    }
  }], [{
    key: "create",
    value: function create(iterator, scheduler) {
      return new IteratorObservable(iterator, scheduler);
    }
  }, {
    key: "dispatch",
    value: function dispatch(state) {
      var index = state.index,
          hasError = state.hasError,
          iterator = state.iterator,
          subscriber = state.subscriber;

      if (hasError) {
        subscriber.error(state.error);
        return;
      }

      var result = iterator.next();

      if (result.done) {
        subscriber.complete();
        return;
      }

      subscriber.next(result.value);
      state.index = index + 1;

      if (subscriber.closed) {
        if (typeof iterator.return === 'function') {
          iterator.return();
        }

        return;
      }

      this.schedule(state);
    }
  }]);
  return IteratorObservable;
}(_Observable2.Observable);

exports.IteratorObservable = IteratorObservable;

var StringIterator =
/*#__PURE__*/
function () {
  function StringIterator(str) {
    var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : str.length;
    (0, _classCallCheck2.default)(this, StringIterator);
    this.str = str;
    this.idx = idx;
    this.len = len;
  }

  (0, _createClass2.default)(StringIterator, [{
    key: _iterator.iterator,
    value: function value() {
      return this;
    }
  }, {
    key: "next",
    value: function next() {
      return this.idx < this.len ? {
        done: false,
        value: this.str.charAt(this.idx++)
      } : {
        done: true,
        value: undefined
      };
    }
  }]);
  return StringIterator;
}();

var ArrayIterator =
/*#__PURE__*/
function () {
  function ArrayIterator(arr) {
    var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : toLength(arr);
    (0, _classCallCheck2.default)(this, ArrayIterator);
    this.arr = arr;
    this.idx = idx;
    this.len = len;
  }

  (0, _createClass2.default)(ArrayIterator, [{
    key: _iterator.iterator,
    value: function value() {
      return this;
    }
  }, {
    key: "next",
    value: function next() {
      return this.idx < this.len ? {
        done: false,
        value: this.arr[this.idx++]
      } : {
        done: true,
        value: undefined
      };
    }
  }]);
  return ArrayIterator;
}();

function getIterator(obj) {
  var i = obj[_iterator.iterator];

  if (!i && typeof obj === 'string') {
    return new StringIterator(obj);
  }

  if (!i && obj.length !== undefined) {
    return new ArrayIterator(obj);
  }

  if (!i) {
    throw new TypeError('object is not iterable');
  }

  return obj[_iterator.iterator]();
}

var maxSafeInteger = Math.pow(2, 53) - 1;

function toLength(o) {
  var len = +o.length;

  if (isNaN(len)) {
    return 0;
  }

  if (len === 0 || !numberIsFinite(len)) {
    return len;
  }

  len = sign(len) * Math.floor(Math.abs(len));

  if (len <= 0) {
    return 0;
  }

  if (len > maxSafeInteger) {
    return maxSafeInteger;
  }

  return len;
}

function numberIsFinite(value) {
  return typeof value === 'number' && _root.root.isFinite(value);
}

function sign(value) {
  var valueAsNumber = +value;

  if (valueAsNumber === 0) {
    return valueAsNumber;
  }

  if (isNaN(valueAsNumber)) {
    return valueAsNumber;
  }

  return valueAsNumber < 0 ? -1 : 1;
}